import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';
import { DNOTE_SERVICE_URL } from 'constants/urls';

import Skeleton from '@mui/material/Skeleton';
import { useGetList } from 'react-admin';
import { Link as RouterLink } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { TextFieldWithCopyButton } from 'shared/mui/Fields';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Link } from 'shared/mui/Link/Link';
import { ApiClient } from 'types/embedded/apiClient';
import { ApiKey } from 'types/embedded/apiKey';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  record?: ApiClient;
};

export const ApiClientsListApiKeysFieldShowDialog: React.FC<Props> = ({
  open,
  onClose,
  record,
}) => {
  const { data: [apiKey] = [], isLoading } = useGetList<ApiKey>(
    'api_keys',
    {
      pagination: UNLIMITED_PAGINATION_PARAMS,
      filter: { apiClient: record?.id },
    },
    { enabled: !!record },
  );

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        title="Ключ API"
        titleSize="smallBold"
      />
      <CardContent sx={{ paddingBottom: '24px!important' }}>
        <Alert severity="info" sx={{ marginBottom: '16px' }}>
          Используйте внутренний сервис{' '}
          <Link
            component={RouterLink}
            sx={{ color: 'primary.main' }}
            target="_blank"
            to={DNOTE_SERVICE_URL}
          >
            DNOTE
          </Link>{' '}
          для передачи значения ключа API.
        </Alert>
        {isLoading ? (
          <Skeleton height={40} variant="rounded" />
        ) : (
          <TextFieldWithCopyButton
            disabled
            fullWidth
            size="small"
            sx={{ marginTop: 0 }}
            value={apiKey?.value || ''}
            variant="outlined"
          />
        )}
      </CardContent>
    </Dialog>
  );
};
